export default "__VITE_ASSET__1d032df8__"